import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material"
import HubLogo from "../../common/images/843logo_white.png"
import Instagram from "../../common/images/instagram_logo.png"
import useIsMobile from "@/hooks/useIsMobile"

export default function AboutUsFooter() {
  const isMobile = useIsMobile()

  return isMobile ? (
    <Box
      display="flex"
      flexDirection="column"
      width="94%"
      paddingTop={2}
      paddingY={4}
      paddingBottom={8}
      justifyContent="space-between"
      sx={{
        color: "white",
        position: "relative",
      }}
    >
      <Typography variant="h3">News Letter</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >
        <TextField
          fullWidth
          placeholder="Email Address"
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-input": {
              padding: "10px 16px",
            },
          }}
        />
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#4CAF50", // Green color
            color: "white",
            textTransform: "none",
            borderRadius: "8px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#45a049", // Slightly darker green on hover
            },
          }}
        >
          Subscribe
        </Button>
      </Box>
      <Stack spacing={2} pt={2}>
        <Typography variant="h3">Contact</Typography>
        <Typography>
          Email:{" "}
          <a href="mailto:info@843hub.com" style={{ color: "white" }}>
            info@843hub.com
          </a>
        </Typography>
        <Typography>
          Phone:{" "}
          <a href="tel:+18436996190" style={{ color: "white" }}>
            843-699-6190
          </a>
        </Typography>
        <Typography>Address: Charleston, SC</Typography>
      </Stack>
    </Box>
  ) : (
    <Box
      display="flex"
      flexDirection="row"
      width="94%"
      paddingTop={2}
      paddingY={4}
      justifyContent="space-between"
      sx={{
        color: "white",
        position: "relative",
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h3">Contact</Typography>
        <Typography>
          Email:{" "}
          <a href="mailto:info@843hub.com" style={{ color: "white" }}>
            info@843hub.com
          </a>
        </Typography>
        <Typography>
          Phone:{" "}
          <a href="tel:+18436996190" style={{ color: "white" }}>
            843-699-6190
          </a>
        </Typography>
        <Typography>Address: Charleston, SC</Typography>
      </Stack>
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Center logo horizontally and vertically
        }}
      >
        <img
          src={HubLogo}
          alt="843Hub logo - Charleston events platform"
          height={"auto"}
          width={140}
        />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="h3">News Letter</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <TextField
            fullWidth
            placeholder="Email Address"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "white",
              },
              "& .MuiOutlinedInput-input": {
                padding: "10px 16px",
              },
            }}
          />
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#4CAF50", // Green color
              color: "white",
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#45a049", // Slightly darker green on hover
              },
            }}
          >
            Subscribe
          </Button>
        </Box>
        <Divider sx={{ backgroundColor: "white", height: "1px" }} />
        {/* social media list */}
        <Box
          component="a"
          href="https://www.instagram.com/843hub"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "inline-block",
            textDecoration: "none",
          }}
        >
          <Box
            component="img"
            src={Instagram}
            alt="Example"
            sx={{
              width: 58,
              height: 58,
            }}
          />
        </Box>
      </Stack>
    </Box>
  )
}
